module.exports = __webpack_public_path__ + "img/motor_no54.5ad2df34.jpg";